/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Date_Range_ReversedInputs */

const vi_error_date_range_reversed = /** @type {(inputs: Error_Date_Range_ReversedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Từ ngày" đang sau "Đến ngày" — chọn lại khoảng ngày.`)
};

/**

* @param {Error_Date_Range_ReversedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_date_range_reversed = /** @type {((inputs?: Error_Date_Range_ReversedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Date_Range_ReversedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_date_range_reversed(inputs)
});